import { IProduct, Product } from './product';

export interface ICertification extends IProduct {
  isAuditRequired: boolean;
  isAEC: boolean;
  price: number;
}

export class Certification extends Product implements ICertification {
  isAuditRequired: boolean;
  isAEC: boolean;
  price: number;
}